jQuery(document).ready(function($) {

    if ($('.pdf-docs').length < 1 ) {
        return;
    }

    var sportSelect = $('.sport-select');
    var gameSelect =  $('.game-select');

    //////////////////
    // detect change on selects
    //////////////////

    sportSelect.change(function(e){

        var selectedSport = $(e.target).find('option:selected');
        var id = selectedSport.val();
        var selectedGames = $('.game-select option[data-parent="' + id + '"]');
        var childless = $(selectedSport).attr('data-childess');
        
        gameSelect.removeClass('hide');
        $('.game-select option').addClass('hide');

        selectedGames.removeClass('hide');

        if (childless) {
            $('.pdf-docs').addClass('extend');

            gameSelect.addClass('hide');
            showDocument(sportSelect.val() );

        } else {
            $('.pdf-docs').removeClass('extend');

            if (selectedGames[0]) { // sub games found
                gameSelect.val($(selectedGames[0]).val());
                showDocument(gameSelect.val() );
            } else { // NO sub games found
                $('option.none').removeClass('hide');
                gameSelect.val(0);
            }
        }


    });

    gameSelect.change(function(e){
        showDocument(gameSelect.val() );
    });

    //////////////////
    // reveal a document
    //////////////////

    function showDocument(id) {
        var docMatch = $('.pdf-doc[data-game="' + id + '"]');
        $('.pdf-doc').addClass('hide');
        if (docMatch.length > 0 ) {
            docMatch.removeClass('hide');
        } else {
            $('[data-game="0"]').removeClass('hide');
        }
    }

    //////////////////
    // sort selects alphabetically
    //////////////////

    // choose target dropdown
    // var select = $('select');
    sportSelect.html(sportSelect.find('option').sort(function(x, y) {
        // to change to descending order switch "<" for ">"
        return $(x).text() > $(y).text() ? 1 : -1;
    }));
    
    // select default item after sorting (first item)
    $('select').get(0).selectedIndex = 0;


});